export default {
  computed: {
    metaTitle () {
      const isWomenSegment = this.$route.name?.startsWith('lang-women')
      const isMenSegment = this.$route.name?.startsWith('lang-men')

      if (isWomenSegment) {
        return this.$t('HomePage.OTAWomen')
      }

      if (isMenSegment) {
        return this.$t('HomePage.OTABoxerShorts')
      }

      return this.$t('HomePage.OTAGeneral')
    }
  }
}
